class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.bindDialog();

    // A modal dialog reports itself as the click target for the whole dimmed area, not just its box.
    this.addEventListener('click', (event) => {
      if (event.target === this._dialog) this.close();
    });
    this.setHeaderCartIconAccessibility();

    if(window.theme.gwp.enable) {
      this.addEventListener('submit', this.onSubmit.bind(this), true); // `true` = capture phase
    }
  }

  async onSubmit(event) {
    const form = event.target;

    if (!form.matches('form[action*="/cart"]')) {
      return;
    }
    
    if(!(customer?.tags.includes("swell_vip_platinum") || customer?.tags.includes("swell_vip_gold"))) return;
    if(!customer?.tags.includes("loyaltyconsent_yes")) return;
    if(customer?.tags.includes("GWP Received")) return;

    const gwpVariantId = String(window.theme.gwp.variant_id);

    // Select your specific inputs
    const qtyInputs = form.querySelectorAll('input.quantity__input[data-quantity-variant-id]');

    qtyInputs.forEach((input) => {
      const variantId = input.dataset.quantityVariantId;

      if (variantId === gwpVariantId) {
        const current = parseInt(input.value, 10) || 0;

        if (current > 1) {
          // Clamp the value BEFORE the browser serializes the form
          input.value = 1;
          console.log('GWP quantity clamped to 1 before submit');
        }
      }
    });
    return;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // renderContents() replaces #CartDrawer's innerHTML, so the dialog and its listener must be re-cached.
  bindDialog() {
    this._dialog = this.querySelector('dialog.drawer__inner');
    this._dialog?.addEventListener('close', () => this.onDialogClose());
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    // showModal() throws if already open — renderContents() re-opens the same instance on cart updates.
    if (!this._dialog?.open) this._dialog?.showModal();

    document.body.classList.add('overflow-clip');
  }

  // Moves focus to new content after a re-render (quantity update, empty-cart state).
  retrapFocus(container, elementToFocus) {
    (elementToFocus?.isConnected ? elementToFocus : container)?.focus();
  }

  // The close transition (transform + display) is driven by CSS off the dialog's own [open]
  // attribute (see component-cart-drawer.css), so close() can call dialog.close() directly.
  close() {
    if (!this._dialog?.open) return;
    this.classList.remove('active');
    this._dialog.close();
  }

  // Runs regardless of how the dialog closed (close(), backdrop click, or native Escape).
  onDialogClose() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-clip');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.bindDialog();
      this.open();
    });
  }

  disableCheckout() {
    this.querySelector('button#CartDrawer-Checkout').disabled = true;
  }

  enableCheckout() {
    this.querySelector('button#CartDrawer-Checkout').disabled = false;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
